import {
  BaseModel,
  type TargetableModel,
} from '@cotera/client/v0/actions/framework';

/**
 * Base for per-entity workflow canvas view models. Uses the registry entity id
 * (agent id, trigger id, …) as {@link Model.id} for ModelScope registration.
 */
export abstract class WorkflowEntityNodeModel
  extends BaseModel
  implements TargetableModel
{
  private _isTargeted = false;

  protected constructor(entityId: string) {
    super(entityId);
  }

  get isTargeted(): boolean {
    return this._isTargeted;
  }

  target(): void {
    this._isTargeted = true;
  }

  markAsNotTargeted(): void {
    this._isTargeted = false;
  }

  abstract dispose(): void;
}
